module.exports = __webpack_public_path__ + "img/placeholder.2d69d24d.svg";